import React, { useEffect, useState } from 'react'
import { getInitialProps, useTranslation } from "react-i18next";

import i18next from 'i18next'
import { Link, useHistory, withRouter } from 'react-router-dom';
import {
    addReadOnly,
    getLanguage,
    getUserId,
    removeReadOnly,
    showErrorToastMessage,
    showToastMessage,
    t
} from '../../helpers/CommonHelper';
import OtpInput from 'react-otp-input';
import api from '../../services/baseapi';
import { Component } from 'react';
import { Fragment } from 'react';
import format from 'date-fns/format';
import CIcon from '@coreui/icons-react';

export const HeaderBeforeLogin = (props) => {
    let storedLng = getLanguage();
    storedLng = storedLng === "bn" ? "bn" : "en";
    const [lang, setLang] = useState(storedLng);
    const [t] = useTranslation();

    const changLanguage = (ln) => {
        setLang(ln);
        i18next.changeLanguage(ln);
        window.location.reload();
    }

    const headerStyle = { position: "sticky", top: "0", background: "#bedcc8", borderBottom: "1px solid #96dbbe", zIndex: 99, boxShadow: "#56565621 0px 2px 2px" }
    const homeUrl = getUserId() ? "/dashboard" : "/login";

    return <div className="row pt-2 mb-2" style={headerStyle}>
        <div className="col-7 black pb-2">
            <div className="d-block d-sm-none"><Link to="/login">{t("lbl.mblInternetBanking")}</Link></div>
            <div className="d-none d-sm-block">
                <span style={{fontSize: 16}}>{t("lbl.welcomeToMblInternetBanking")}</span>
            </div>
        </div>
        {false &&
            <div className="col-5 pb-2 text-right light-font pointer z-index-up" >
                <span className={lang !== "bn" ? "blue font-weight-bold" : ""} onClick={() => { changLanguage('en') }}>English</span>
                <span> | </span>
                <span className={lang === "bn" ? "blue font-weight-bold" : ""} onClick={() => { changLanguage('bn') }}>বাংলা</span>
            </div>
        }
        <div className="col-12 pr-0 pl-0 text-center">
            {props.loginLink && <Link className="home-btn" to={homeUrl}>{t("lbl.goToHome")}</Link>}
        </div>
    </div>
}

export const FooterCommon = () => {
    const [t] = useTranslation();

    const footerStyle = { position: "sticky", bottom: "0" }
    const hasFooterLinks = window.location.href.includes("/dashboard") || !getUserId();

    return <div className="light-font" style={footerStyle}>
        {hasFooterLinks && <div className="row" style={{ background: "#e1e9e1", boxShadow: "#56565621 0px -2px 1px" }}>
            <div className="col-12 text-center footer-link mt-2 mb-2">
                <Link to="/faq">{t('lbl.faq')}</Link>|
                <Link to="/privacy-policy">{t('lbl.privacyPolicy')}</Link>|
                <Link to="/register-manual">{t('lbl.registerManual')}</Link>|
                <Link to="/safety-instruction">{t('lbl.safetyInstructionTips')}</Link>|
                <Link to="/atm-location">{t('lbl.atmLocation')}</Link>|
                <Link to="/branch-location">{t('lbl.branchLocation')}</Link>|
                <Link to="/about">{t('lbl.about')}</Link>|
                <Link to="/contact-us">{t('lbl.contactUs')}</Link>
            </div>
        </div>}
        <div className="d-none d-sm-block">
            <div className="row black p-2" style={{ background: "#bedcc8" }}>
                <div className="col-12 col-sm-6">&copy; {new Date().getFullYear()} Mercantile Bank Limited</div>
                <div className="col-12 col-sm-6 text-muted text-right"><a href="https://konasl.com/">Developed by Kona Software Lab Ltd</a></div>
            </div>
        </div>
    </div>
}

export const SideBannerBeforeLogin = () => {

    return <div className="d-none d-lg-block col-md-6 vh-100 pl-0 pr-0">
        <img className="w-100 h-100" src={process.env.PUBLIC_URL + "/img_login_banner.gif"} />
    </div>
}

export const LogoBox = () => {
    return <div className="login_box_top">
        <img src={process.env.PUBLIC_URL + "/login_sy_logo.svg"} />
    </div>
}

export const PasswordPolicy = () => {
    return <div className="alert alert-info p-1">
        <small>
            <ul className="m-1">
                <li>{t("msg.passwordPolicy.1")}</li>
                <li>{t("msg.passwordPolicy.2")}</li>
                <li>{t("msg.passwordPolicy.3")}</li>
            </ul>
        </small>
    </div>
}

export const InfoPageLayout = (props) => {
    return <div className="container-fluid">
        <div className="row">
            <div className="col-12 vh-100 logbox-layout">
                <HeaderBeforeLogin loginLink={props.loginLink} />
                <div className="row  pr-3 pl-3 pb-10 pt-4" style={{ flexGrow: 1 }}>
                    <div className="col-12 col-sm-10 offset-sm-1" style={{ flexGrow: 1 }}>
                        <h1 className="mb-4">{props.header}</h1>
                        {props.pageContent}
                    </div>
                </div>
                <FooterCommon />
            </div>
        </div>
    </div>
}

export const requiredSign = () => {
    return <span className="text-danger">*</span>
}

export const successIcon = () => {
    return <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 150 150">
        <path style={{ fill: "#4bd384" }} d="M75,2.67A72.33,72.33,0,1,0,147.33,75,72.42,72.42,0,0,0,75,2.67Z" />
        <path style={{ fill: "#4bd384" }} d="M75,12.91A62.09,62.09,0,1,0,137.09,75,62.16,62.16,0,0,0,75,12.91Z" />
        <path style={{ fill: "#fff" }} d="M109.7,58.66,70,98a6.11,6.11,0,0,1-8.56.15L40.46,79A6.31,6.31,0,0,1,40,70.33,6.16,6.16,0,0,1,48.7,70L65.35,85.27l35.48-35.48a6.27,6.27,0,0,1,8.87,8.87Z" />
    </svg>
}

export const getSelectedAccount = (accountNo, accountList) => {
    let account = accountList.find(x => x.accountNo == accountNo);
    return account || {};
}

export const SuccessfulTransactionSummary = (props) => {
    let account = getSelectedAccount(props.accountNo, props.accountList || []);
    let trx = props.trxResponse;
    let otherAmounts = trx ? trx.otherAmounts : "";
    let trxDate = (trx && trx.responseTime) ? formatTrxDate(trx.responseTime) : "";
    let grandTotal = 0;
    if (trx) grandTotal = parseFloat(otherAmounts.COMMISSION) + parseFloat(otherAmounts.FEE) + parseFloat(otherAmounts.TXN);

    return <div>
        <div className="text-center">
            <div className="mx-auto mb-2" style={{ width: 100 }}>{successIcon()}</div>
            {props.header && <h5>{props.header}</h5>}
            {props.subHeader && <p>{props.subHeader}</p>}
        </div>
        <div className="container">
            <hr />
            <div className="row">
                <div className="col-12 col-sm-8 mx-auto">
                    <Fragment>

                        {trx ? lblValueStretch(t("Transaction Date Time"), trxDate) : ""}
                        {trx ? lblValueStretch(t("IB Transaction Ref No"), trx.trxReferenceNumber || "") : ""}
                        {trx ? lblValueStretch(t("CBS Transaction Ref No"), trx.cbsTxnReferenceNumber || "") : ""}
                        {account?.accountNo ? lblValueStretch(t("lbl.fromAccount"), account.accountNo || "") : ""}
                        {account?.accountTitle ? lblValueStretch(t("lbl.accountName"), account.accountTitle || "") : ""}
                        {trx ? lblValueStretch(t("lbl.transactionAmount"), otherAmounts.TXN + " BDT" || "") : ""}
                        {trx ? lblValueStretch(t("lbl.commission"), otherAmounts.COMMISSION + " BDT" || "") : ""}
                        {trx ? lblValueStretch(t("lbl.fee"), otherAmounts.FEE + " BDT" || "") : ""}
                        {trx ? lblValueStretch(t("lbl.grandTotal"), grandTotal + " BDT" || "") : ""}
                    </Fragment>
                    {(props.extraInfoList && props.extraInfoList.length) &&
                        <Fragment>
                            {props.extraInfoList.map(item => {
                                return lblValueStretch(item.lbl, item.val);
                            })}
                        </Fragment>
                    }
                </div>
            </div>
        </div>
    </div>
}


export const SuccessfulCardPayment = (props) => {
    console.log("PROPS : +=========>", props)

    let account = getSelectedAccount(props.accountNo, props.accountList || []);
    let trx = props.trxResponse;
    let otherAmounts = trx ? trx.otherAmounts : "";
    let trxDate = (trx && trx.responseTime) ? formatTrxDate(trx.responseTime) : "";
    let trxDate2 = (trx && trx.responseTime) ? trx.responseTime.split("+"): "";

    let grandTotal = 0;
    if (trx) grandTotal = parseFloat(otherAmounts.COMMISSION) + parseFloat(otherAmounts.FEE) + parseFloat(otherAmounts.TXN);
    let {name,cardType,cardBrand} = props.cardInfo;
    let currency = props.paymentMode === "LOCAL" ? "BDT":"USD"
    return <div>
        <div className="text-center">
            <div className="mx-auto mb-2" style={{ width: 100 }}>{successIcon()}</div>
            {props.header && <h5>{props.header}</h5>}
            {props.subHeader && <p>{props.subHeader}</p>}
        </div>
        <div className="container">
            <hr />
            <div className="row">
                <div className="col-12 col-sm-8 mx-auto">
                    <Fragment>

                        {trx ? lblValueStretch(t("Transaction Date Time"), trxDate) : ""}
                        {trx ? lblValueStretch(t("IB Transaction Ref No"), trx.trxReferenceNumber || "") : ""}
                        {/*cbstrxid is not available*/}
                        {trx ? lblValueStretch(t("CBS Transaction Ref No"), trx.cbsTxnReferenceNumber || "") : ""}
                        {account?.accountNo ? lblValueStretch(t("lbl.fromAccount"), account.accountNo || "") : ""}
                        {account?.accountTitle ? lblValueStretch(t("Cardholder Name"), name || "") : ""}
                        {account?.accountTitle ? lblValueStretch(t("Card Number"), props.cardNo  || "") : ""}
                        {account?.accountTitle ? lblValueStretch(t("Card Type"), cardBrand|| "") : ""}
                        {account?.accountTitle ? lblValueStretch(t("Currency"), currency || "") : ""}
                        {trx ? lblValueStretch(t("lbl.transactionAmount"), otherAmounts.TXN + " BDT" || "") : ""}
                        {trx ? lblValueStretch(t("lbl.commission"), otherAmounts.COMMISSION + " BDT" || "") : ""}
                        {trx ? lblValueStretch(t("lbl.fee"), otherAmounts.FEE + " BDT" || "") : ""}
                        {trx ? lblValueStretch(t("lbl.grandTotal"), grandTotal + " BDT" || "") : ""}
                    </Fragment>
                    {(props.extraInfoList && props.extraInfoList.length) &&
                    <Fragment>
                        {props.extraInfoList.map(item => {
                            return lblValueStretch(item.lbl, item.val);
                        })}
                    </Fragment>
                    }
                </div>
            </div>
        </div>
    </div>
}


export const SuccessTopUp = (props) => {
    let account = getSelectedAccount(props.accountNo, props.accountList || []);
    let trx = props.trxResponse;
    let otherAmounts = trx ? trx.otherAmounts : "";
    let trxDate = (trx && trx.responseTime) ? format(new Date(trx.responseTime), "dd MMMM yyyy") : "";
    let grandTotal = 0;
    if (trx) grandTotal = parseFloat(otherAmounts.COMMISSION) + parseFloat(otherAmounts.FEE) + parseFloat(otherAmounts.TXN);

    return <div>
        <div className="text-center">
            <div className="mx-auto mb-2" style={{ width: 100 }}>{successIcon()}</div>
            {props.header && <h5>{props.header}</h5>}
            {props.subHeader && <p>{props.subHeader}</p>}
        </div>
        <div className="container">
            <hr />
            <div className="row">
                <div className="col-12 col-sm-8 mx-auto">
                    <Fragment>
                        {trx ? lblValueStretch(t("lbl.transactionNo"), trx.trxReferenceNumber || "") : ""}
                        {trx ? lblValueStretch(t("lbl.transactionDate"), trxDate) : ""}

                        {trx ? lblValueStretch(t("lbl.transactionAmount"), otherAmounts.TXN + " BDT" || "") : ""}
                        {trx ? lblValueStretch(t("lbl.commission"), otherAmounts.COMMISSION + " BDT" || "") : ""}
                        {trx ? lblValueStretch(t("lbl.fee"), otherAmounts.FEE + " BDT" || "") : ""}
                        {trx ? lblValueStretch(t("lbl.grandTotal"), grandTotal + " BDT" || "") : ""}
                    </Fragment>
                    {(props.extraInfoList && props.extraInfoList.length) &&
                    <Fragment>
                        {props.extraInfoList.map(item => {
                            return lblValueStretch(item.lbl, item.val);
                        })}
                    </Fragment>
                    }
                </div>
            </div>
        </div>
    </div>
}

export const OtpCheckLabel = (props) => {
    return <small className="text-muted ml-2">({t("lbl.checkYour")}<strong> {t("lbl.sms")}</strong> {t("lbl.or")} <strong>{t("lbl.email")}</strong>)</small>
}

export const rowitemValue = (label, value) => {
    return <div className="row">
        <div className="col-6 col-sm-3 text-right">
            <label className="col-form-label">{label}:</label>
        </div>
        <div className="col-6 col-sm-9">
            <label className="col-form-label">{value}</label>
        </div>
    </div>
}

export const lblValueStretch = (label, value) => {
    return <div className="row">
        <div className="col-6 col-sm-4">
            <label className="col-form-label" style={{ color: "#777" }}>{label}:</label>
        </div>
        <div className="col-6 col-sm-8 text-right">
            <label className="col-form-label">{value}</label>
        </div>
    </div>
}

export const stepNavigation = (prevFunction, nextFunction, prevLabel, nextLabel) => {
    return <div className="row">
        <div className="col-12 clearfix">
            {prevFunction && <button className="btn btn-info w-100px" onClick={() => { prevFunction(); }}>{prevLabel || t("lbl.previous")}</button>}
            {nextFunction && <button className="btn btn-success float-right w-100px" onClick={() => { nextFunction(); }}>{nextLabel || t("lbl.next")}</button>}
        </div>
    </div>
}

export const InputRow = (props) => {
    let name = props.name;
    let label = props.label || t("lbl." + name);
    let redStar = props.required ? requiredSign() : "";
    let value = props.value || "";
    let instruction = props.instruction || "";
    let inputAttributes = props.inputAttributes || {};
    let maxLength = props.maxLength || "100";

    const inputGroup = <Fragment>
        <div className="input-group">
            {props.prepend &&
                <div className="input-group-prepend">
                    <div className="input-group-text">{props.prepend.label}</div>
                </div>
            }
            {props.type === "password" ?
                <InputPassword
                    value={value}
                    onChange={props.onChange || null}
                    maxLength={maxLength}
                    name={name}
                />
                : props.type === "pin" ?
                    <InputPin
                        name={name}
                        value={value}
                        placeholder={props.placeholder || label}
                        onChange={props.onChange || null}
                    />
                    : <input
                        name={name}
                        id={name}
                        className={"form-control"}
                        maxLength={maxLength}
                        onChange={props.onChange || null}
                        {...inputAttributes}
                        value={value}
                        autoComplete="off"
                    />
            }
            {props.append && <div className="input-group-append">
                <span className="input-group-text" style={props.append.onClick ? { cursor: "pointer" } : {}}
                    onClick={() => {
                        if (props.append.onClick) props.append.onClick();
                    }}
                >{props.append.label}</span>
            </div>}
        </div>
        {instruction && <small>{instruction}</small>}
    </Fragment>

    return props.noRow ?
        <div className="form-group">
            <label htmlFor={name} className="col-form-label">{label}{redStar}</label>
            {inputGroup}
        </div>
        : <div className="form-group row">
            <div className="col-12 col-sm-3 text-sm-right">
                <label htmlFor={name} className="col-form-label">{label}{redStar}</label>
            </div>
            <div className="col-12 col-sm-9">
                {inputGroup}
            </div>
        </div>
}

export const InputPassword = (props) => {
    return <Fragment>
        <input maxLength={props.maxLength || 120}
            autoComplete="off"
            onChange={props.onChange}
            value={props.value}
            type="password"
            name={props.name}
            className="form-control"
            id={props.name}
            placeholder={props.placeholder || ""}
            style={{ backgroundColor: "#fff" }} />
    </Fragment>
}

export const formatTrxDate = (date) => {
    if(!date) return "N/A";
    return format(new Date(date.replace(/\..../,"")), "dd/MM/yyyy hh:mm:ss aa");
}

export const InputPin = (props) => {
    let hasWebKit = window.getComputedStyle(document.getElementsByTagName("div")[0]).webkitTextSecurity ? true : false;
    return <input maxLength={"6"}
        autoComplete="off"
        onChange={props.onChange}
        value={props.value}
        name={props.name}
        type={hasWebKit ? "text" : "password"}
        className="form-control pin-input"
        id={props.name}
        inputMode="numeric"
        placeholder={props.placeholder || "Enter PIN"} />
}

class OtpWithResend extends Component {
    constructor(props) {
        super(props)
        this.state = {
            byPassResendOtp: props.byPassResendOtp,
            remainingOtpTime: props.remainingOtpTime || 60,
            isOtpResendDisabled: true,
            otpReferenceNo: props.otpReferenceNo,
            remainingResendCount: props.remainingResendCount || 3
        }
        this.timer = 0;
    }

    componentDidMount() {
        this.setTimerStart(this.props.remainingOtpTime);
    }

    setTimerStart = (e) => {
        this.setState({
            remainingOtpTime: e || 120,
            isOtpResendDisabled: true
        }, () => {
            this.timer = 0;
            this.timer = setInterval(this.initiate, 1000);
        })
    }

    initiate = () => {
        let remSeconds = this.state.remainingOtpTime - 1;
        this.setState({
            remainingOtpTime: remSeconds,
        })
        if (remSeconds === 0) {
            this.setState({ isOtpResendDisabled: false });
            clearInterval(this.timer);
        }
    }

    resendOtp = () => {
        const state = this.state
        if (state.remainingResendCount === 1) {
            alert(t("msg.resubmitRequest"));
            this.toHome();
            return;
        }

        let data = this.props.isUserMapOtp ?
            {
                "userId": this.props.userId,
                "event": this.props.event,
                "otpChannel": this.props.otpChannel
            }
            : {
                otpReferenceNo: state.otpReferenceNo,
                trxReferenceNumber: this.props.trxReferenceNumber
            }

        if (this.props.isUserMapOtp && this.props.userId === undefined) {
            console.log(this.props.resendData);
            api.post("/api/users/send-registration-otp", this.props.resendData)
                .then(res => {
                    this.setTimerStart(this.props.remainingOtpTime);
                    this.setState({
                        remainingResendCount: 5
                    })
                    this.props.resendCallback(res.data);
                })
                .catch(err => {
                });
            return;
        }

        if (this.props.byPassResendOtp) {
            this.setTimerStart(this.props.remainingOtpTime);
            this.props.byPassResendOtp();
            return;
        }

        let url = this.props.isUserMapOtp ? "/api/users/map/resend-map-otp" : "/api/resend/trx-otp";
        api.post(url, data).then(response => {
            console.log()
            console.log(this.props.remainingOtpTime)
            if(response.data.resendDuration != null){
                this.setTimerStart(response.data.resendDuration);
            }else {
                this.setTimerStart(this.props.remainingOtpTime);
            }

            this.setState({
                remainingResendCount: response.data.remainingResendCount,
                otpReferenceNo: response.data.otpReferenceNo
            })
            this.props.resendCallback(response.data);
        }).catch(err => {
            let errorMessage = err.response.data.devMessage.replace("Registration service failed. ","");
            showErrorToastMessage(errorMessage, "FAILED", "");
        })
    }

    toHome = () => {
        window.location.reload();
        // const homeUrl = getUserId() ? "/dashboard" : "/login";
        // this.props.history.push(homeUrl);
    }

    getTime () {
        const min = Math.floor(this.state.remainingOtpTime / 60);
        const sec = this.state.remainingOtpTime % 60;

        return min > 0 ? min.toString() + ' minute ' + ('0' + sec).slice(-2) + ' seconds' : ('0' + sec).slice(-2) + ' seconds';
    }

    render() {
        const state = this.state;
        const props = this.props;
        //Otp input Attributes
        let shouldAutoFocus = props.shouldAutoFocus || true;
        let isInputNum = props.isInputNum || true;
        let hasErrored = props.hasErrored || false;
        let inputStyle = props.inputStyle || "otpInputStyle";
        let numInputs = props.numInputs || 6;
        let errorStyle = props.errorStyle || "otpErrorStyle";
        let inputAttributes = props.inputAttributes || {};

        return <div className="d-flex justify-content-center align-items-center container">
            <div className="mt-2 p-2 text-center">
                <h6>{t("msg.enterOtp")}</h6>
                <p className="text-muted"> {t("msg.anOtpSent")}</p>
                <OtpInput
                    shouldAutoFocus={shouldAutoFocus}
                    isInputNum={isInputNum}
                    hasErrored={hasErrored}
                    isDisabled={false}
                    inputStyle={inputStyle}
                    value={props.value}
                    onChange={props.onChange}
                    numInputs={numInputs}
                    errorStyle={errorStyle}
                    containerStyle={{ "justifyContent": "center" }}
                    {...inputAttributes}
                />
                {!props.isOnlyOtp &&
                    <div className="btn-row mt-2">
                        {!state.isOtpResendDisabled ?
                            <div> <span className="text-muted">{t("msg.otpNotSend")}</span>
                                <span className="text-info pointer"
                                    onClick={this.resendOtp}>&nbsp;{t("lbl.resendOtp")}</span>
                            </div> :
                            <div> <span className="text-muted">{t("lbl.remainingTime")}</span>: {this.getTime()}</div>
                        }
                        <div className="pointer text-info" onClick={() => {
                            if (!window.confirm(t("msg.clearOtp"))) return;
                            props.onChange("");
                        }}>{t("msg.wrongNumber")}</div>
                    </div>
                }
            </div>
        </div>

    }
}
export default withRouter(OtpWithResend);
